import { Stack } from '@mantine/core';
import { Title } from '@repo/foundations';
import { observer } from 'mobx-react-lite';

import { toJS } from 'mobx';
import { useCallback, useMemo, useRef } from 'react';
import { useCustomFilterOptionsConfig } from '../../../components/Filter/useCustomFilterOptionsConfig';
import { FilterBlockController } from '../../../features/FilterBlock';
import { getFilterOptionsForPolicy } from '../utils/policyFilterOptions';
import { useCreatePolicyStore } from './useCreatePolicyStore';

const ResourceSelectionStack = observer(() => {
	const store = useCreatePolicyStore();
	const customOptionsConfig = useCustomFilterOptionsConfig();
	const isInitialCallRef = useRef(true);

	const filterOptions = useMemo(
		() => getFilterOptionsForPolicy(customOptionsConfig, store.dqsEnabled),
		[customOptionsConfig, store.dqsEnabled]
	);

	const handleRuleChange = useCallback(
		(rule: Parameters<typeof store.setResourceRule>[0]) => {
			// First call is always initialization from FilterBlockController - don't mark as user-initiated
			if (isInitialCallRef.current) {
				isInitialCallRef.current = false;
				store.setResourceRule(rule, false);
				return;
			}

			// All subsequent calls are user-initiated
			store.setResourceRule(rule, true);
		},
		[store]
	);

	return (
		<Stack p={0} spacing="md">
			<Stack spacing={0}>
				<Title size="md">Resources</Title>
			</Stack>
			<FilterBlockController
				initialRule={toJS(store.resourceRule)}
				onRuleChange={handleRuleChange}
				filterOptions={filterOptions}
				customSuffix="filter"
			/>
		</Stack>
	);
});

ResourceSelectionStack.displayName = 'ResourceSelectionStack';
export default ResourceSelectionStack;
